import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header-notifications" }
const _hoisted_3 = {
  key: 0,
  class: "notification-logo"
}
const _hoisted_4 = { class: "body-notifications" }
const _hoisted_5 = { class: "notification-item" }
const _hoisted_6 = { class: "notification-date" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "notification-logo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-clock" })
], -1)
const _hoisted_8 = { class: "notification-info" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "notification-logo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-bell" })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "notification-data"
}
const _hoisted_11 = {
  key: 1,
  class: "notification-data"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "notification-data"
}
const _hoisted_15 = {
  key: 3,
  class: "notification-data"
}
const _hoisted_16 = {
  key: 4,
  class: "notification-data"
}
const _hoisted_17 = {
  key: 5,
  class: "notification-data"
}
const _hoisted_18 = {
  key: 6,
  class: "notification-data"
}
const _hoisted_19 = {
  key: 7,
  class: "notification-data"
}
const _hoisted_20 = {
  key: 8,
  class: "notification-data"
}
const _hoisted_21 = {
  key: 9,
  class: "notification-data"
}
const _hoisted_22 = {
  key: 10,
  class: "notification-data"
}
const _hoisted_23 = {
  key: 11,
  class: "notification-data"
}
const _hoisted_24 = {
  key: 12,
  class: "notification-data"
}
const _hoisted_25 = {
  key: 13,
  class: "notification-data"
}
const _hoisted_26 = {
  key: 14,
  class: "notification-data"
}
const _hoisted_27 = {
  key: 15,
  class: "notification-data"
}
const _hoisted_28 = {
  key: 16,
  class: "notification-data"
}
const _hoisted_29 = { class: "modal-footer-notifications" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-notifications", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Notifications")), 1),
        (_ctx.unread > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.unread), 1))
          : _createCommentVNode("", true),
        (_ctx.unread > 0)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: "clickable-text",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.markRead && _ctx.markRead(...args)))
            }, _toDisplayString(_ctx.$t("Mark as read")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (n) => {
          return (_openBlock(), _createElementBlock("div", {
            key: n.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", null, _toDisplayString(_ctx.renderDateTime(n.date)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (n.data.type === 'kyc_accepted')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Your identity verification request was accepted.")), 1)
                    ]))
                  : (n.data.type === 'kyc_rejected')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Your identity verification request was rejected.")), 1),
                        (!n.data.reason)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("A reason was not provided.")), 1))
                          : _createCommentVNode("", true),
                        (n.data.reason)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("A detailed reason was provided")) + ": " + _toDisplayString(n.data.reason), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (n.data.type === 'offer_new')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("You have a new offer for your loan request.")), 1),
                          _createElementVNode("p", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'loan-offer', params: { id: n.data.offerId, rid: n.data.reqId } },
                              onClick: _ctx.close
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("Go to the offer")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "onClick"])
                          ]),
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t("Loan request")) + ": ", 1),
                            _createVNode(_component_router_link, {
                              to: { name: 'loan-request', params: { id: n.data.reqId } },
                              onClick: _ctx.close
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(n.data.reqTitle || _ctx.$t("Untitled")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "onClick"])
                          ])
                        ]))
                      : (n.data.type === 'offer_accepted')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Your offer was accepted.")), 1),
                            _createElementVNode("p", null, [
                              _createVNode(_component_router_link, {
                                to: { name: 'loan-offer', params: { id: n.data.offerId , rid: n.data.reqId} },
                                onClick: _ctx.close
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Go to the offer")), 1)
                                ]),
                                _: 2
                              }, 1032, ["to", "onClick"])
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("Loan request")) + ": ", 1),
                              _createVNode(_component_router_link, {
                                to: { name: 'loan-request', params: { id: n.data.reqId } },
                                onClick: _ctx.close
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(n.data.reqTitle || _ctx.$t("Untitled")), 1)
                                ]),
                                _: 2
                              }, 1032, ["to", "onClick"])
                            ])
                          ]))
                        : (n.data.type === 'offer_closed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("An offer for one of your loan requests was closed.")), 1),
                              _createElementVNode("p", null, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'loan-offer', params: { id: n.data.offerId, rid: n.data.reqId } },
                                  onClick: _ctx.close
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Go to the offer")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "onClick"])
                              ]),
                              _createElementVNode("p", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t("Loan request")) + ": ", 1),
                                _createVNode(_component_router_link, {
                                  to: { name: 'loan-request', params: { id: n.data.reqId } },
                                  onClick: _ctx.close
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(n.data.reqTitle || _ctx.$t("Untitled")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "onClick"])
                              ])
                            ]))
                          : (n.data.type === 'request_closed')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("The loan request you placed a request for was closed. As a result, your offer was also closed.")), 1),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'loan-offer', params: { id: n.data.offerId, rid: n.data.reqId } },
                                    onClick: _ctx.close
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("Go to the offer")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "onClick"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Loan request")) + ": ", 1),
                                  _createVNode(_component_router_link, {
                                    to: { name: 'loan-request', params: { id: n.data.reqId } },
                                    onClick: _ctx.close
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(n.data.reqTitle || _ctx.$t("Untitled")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "onClick"])
                                ])
                              ]))
                            : (n.data.type === 'offer_message')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("You received a new message regarding an active offer.")), 1),
                                  _createElementVNode("p", null, [
                                    _createVNode(_component_router_link, {
                                      to: { name: 'loan-offer', params: { id: n.data.offerId, rid: n.data.reqId } },
                                      onClick: _ctx.close
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("Go to the offer")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "onClick"])
                                  ]),
                                  _createElementVNode("p", null, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Loan request")) + ": ", 1),
                                    _createVNode(_component_router_link, {
                                      to: { name: 'loan-request', params: { id: n.data.reqId } },
                                      onClick: _ctx.close
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(n.data.reqTitle || _ctx.$t("Untitled")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "onClick"])
                                  ])
                                ]))
                              : (n.data.type === 'offer_contract')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("You have a pending contract for an accepted offer.")), 1),
                                    _createElementVNode("p", null, [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'contract', params: { id: n.data.contractId } },
                                        onClick: _ctx.close
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "onClick"])
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'loan-offer', params: { id: n.data.offerId, rid: n.data.reqId } },
                                        onClick: _ctx.close
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("Go to the offer")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "onClick"])
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("Loan request")) + ": ", 1),
                                      _createVNode(_component_router_link, {
                                        to: { name: 'loan-request', params: { id: n.data.reqId } },
                                        onClick: _ctx.close
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(n.data.reqTitle || _ctx.$t("Untitled")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "onClick"])
                                    ])
                                  ]))
                                : (n.data.type === 'initial_transfer')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("An initial transfer has been made for the contract.")), 1),
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_router_link, {
                                          to: { name: 'contract', params: { id: n.data.contractId } },
                                          onClick: _ctx.close
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to", "onClick"])
                                      ])
                                    ]))
                                  : (n.data.type === 'period_payment')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("A periodic payment has been made for the contract.")), 1),
                                        _createElementVNode("p", null, [
                                          _createVNode(_component_router_link, {
                                            to: { name: 'contract', params: { id: n.data.contractId } },
                                            onClick: _ctx.close
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to", "onClick"])
                                        ])
                                      ]))
                                    : (n.data.type === 'period_payment_canceled')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("You cancelled your periodic payments subscription for a contract.")), 1),
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_router_link, {
                                              to: { name: 'contract', params: { id: n.data.contractId } },
                                              onClick: _ctx.close
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to", "onClick"])
                                          ])
                                        ]))
                                      : (n.data.type === 'refund_payment')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("A payment refund has been issued for the contract.")), 1),
                                            _createElementVNode("p", null, [
                                              _createVNode(_component_router_link, {
                                                to: { name: 'contract', params: { id: n.data.contractId } },
                                                onClick: _ctx.close
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to", "onClick"])
                                            ])
                                          ]))
                                        : (n.data.type === 'contract_deleted')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("A contract has been cancelled.")), 1),
                                              _createElementVNode("p", null, [
                                                _createVNode(_component_router_link, {
                                                  to: { name: 'contract', params: { id: n.data.contractId } },
                                                  onClick: _ctx.close
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to", "onClick"])
                                              ])
                                            ]))
                                          : (n.data.type === 'contract_signed')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("You have successfully signed a pending contract.")), 1),
                                                _createElementVNode("p", null, [
                                                  _createVNode(_component_router_link, {
                                                    to: { name: 'contract', params: { id: n.data.contractId } },
                                                    onClick: _ctx.close
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t("Go to the contract")), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to", "onClick"])
                                                ])
                                              ]))
                                            : (n.data.type === 'next_payment')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("You must make a payment within a week.")), 1),
                                                  _createElementVNode("p", null, [
                                                    _createVNode(_component_router_link, {
                                                      to: { name: 'contract', params: { id: n.data.contractId } },
                                                      onClick: _ctx.close
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("Associated contract")), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["to", "onClick"])
                                                  ]),
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("Payment date")) + ": " + _toDisplayString(_ctx.renderDate(n.data.paymentDate)), 1)
                                                ]))
                                              : (n.data.type === 'kyc_illegal')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("The user") + " " + n.data.name + " " +  _ctx.$t("has its name on some list.")), 1),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_router_link, {
                                                        to: { name: 'user-list-info', params: { id: n.data.vId } },
                                                        onClick: _ctx.close
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.$t("See user info")), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["to", "onClick"])
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("Unknown notification.")), 1)
                                                  ]))
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("p", {
          class: "clickable-text",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.seeAllNotifications && _ctx.seeAllNotifications(...args)))
        }, _toDisplayString(_ctx.$t("See all notifications")), 1)
      ])
    ])
  ], 42, _hoisted_1))
}